import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import "./confirmModal.scss";

export default function ConfirmModal({
  isOpen,
  title,
  message,
  onConfirm,
  onCancel,
  confirmText = "Delete",
  cancelText = "Cancel",
}) {
  // Freeze background scrolling while modal is open
  useEffect(() => {
    if (!isOpen) return;

    const previousOverflow = document.body.style.overflow;

    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return createPortal(
    <div className="mini-miles-modal-overlay fuel-fade-in" onClick={onCancel}>
      {/* Stop clicks inside the modal from closing it */}
      <div
        className="mini-miles-modal-chassis"
        role="dialog"
        aria-modal="true"
        aria-labelledby="mini-miles-confirm-title"
        onClick={(e) => e.stopPropagation()}
      >
        <header className="modal-header">
          <h3 id="mini-miles-confirm-title">{title}</h3>
        </header>

        <div className="modal-body">
          <p style={{ whiteSpace: "pre-line" }}>{message}</p>
        </div>

        <footer className="modal-actions-footer">
          <button type="button" className="btn-modal-cancel" onClick={onCancel}>
            {cancelText}
          </button>

          <button
            type="button"
            className="btn-modal-confirm"
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </footer>
      </div>
    </div>,
    document.body
  );
}
